import $ from 'jquery';
import 'slick-carousel';

$(document).ready(function() {
  let heroSliderSpeeds = [7500, 7000];
  $("a[href$='#intro-component']").on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $('#intro-component').offset().top
    }, 900, 'swing');
  });
  $('.ucg-hero-slider-block .slides').on ('init', function() {
    $('.ucg-hero-slider-block .slides .slide-1').find('.image').css({'opacity': '1', 'left': '+100%'}).animate({
      easing: 'ease-in',
      left: "0",
      opacity: 1,
    }, 1000).delay(6000).animate({
      easing: 'ease-out',
      left: "-=100%",
      opacity: 0,
    }, 1500);
    $('.ucg-hero-slider-block .slides .slide-1').find('.words').css({'opacity': '0'}).delay(1000).animate({
      easing: 'ease-in',
      opacity: 1,
    }, 1000).delay(4000).animate({
        easing: 'ease-out',
        opacity: 0,
    }, 1500);
  });
  $('.ucg-hero-slider-block .slides').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    if (nextSlide == slick.slideCount - 1) {
      $('.ucg-hero-slider-block .slides .slide-1').find('.image').css({'opacity': '1', 'left': '0'}).animate({
        easing: 'ease-in',
        left: "0",
        opacity: 1,
      }, 1000);
    }
    $('.ucg-hero-slider-block .slides .slick-slide[data-slick-index="'+ nextSlide +'"]').find('.image').css({'opacity': '1', 'left': '0'}).animate({
      easing: 'ease-in',
      left: "0",
      opacity: 1,
    }, 1000);
    $('.ucg-hero-slider-block .slides .slick-slide[data-slick-index="'+ nextSlide +'"]').find('.words').css({'opacity': '0'}).delay(1000).animate({
      easing: 'ease-in',
      opacity: 1,
    }, 1000);
  });
  $('.ucg-hero-slider-block .slides').on('afterChange', function(event, slick, currentSlide, nextSlide) {
    $('.ucg-hero-slider-block .slides').slick('slickSetOption', 'autoplaySpeed', heroSliderSpeeds[1], true);
    $('.ucg-hero-slider-block .slides .slick-active').find('.image').delay(6000).animate({
      easing: 'ease-out',
      left: "-=100%",
      opacity: 0,
    }, 1500);
    $('.ucg-hero-slider-block .slides .slick-active').find('.words').delay(4000).animate({
      easing: 'ease-out',
      opacity: 0,
    }, 1500);
  });
  if ($('.ucg-hero-slider-block .slides').length) {
    if ($('.ucg-hero-slider-block .slides').find('.slide-2').length) {
      $('.ucg-hero-slider-block .slides').slick({
        arrows: true,
        autoplay: true,
        autoplaySpeed: heroSliderSpeeds[0],
        dots: false,
        nextArrow: '<div class="slick-next"><i class="fa fa-angle-right"></i></div>',
        pauseOnHover: false,
        pauseonFocus: false,
        prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left"></i></div>',
        speed: 1000,
      });
    }
  };
})